.emptyStateContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  flex-direction: column;
  font-size: 14px;
  row-gap: 24px;
  
  svg {
    width: 199px;
    height: 213px;
    cursor: auto;
  }
}

.wrapper {
  flex: 1;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 100vh;
}
